import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Section, { ExpandedContent, SectionHeader, ViewMoreButton } from './Section'
import pluralize from 'pluralize'
import { api } from 'components/api'
import TiledListItemShape from './prop_shapes/tiledListItem'
import { supplierPostsPath } from '../routes/api'
import TiledListItems from './TiledListItems'

const RecentPostsSection = (props) => {
  const [recentPostsPages, setRecentPostsPages] = useState([props.recentPosts])
  const [nextPage, setNextPage] = useState(props.nextPage)

  const loadMorePosts = async () => {
    try {
      const response = await api.get({
        url: supplierPostsPath(props.supplierId),
        params: {
          page: nextPage
        }
      })

      setRecentPostsPages([...recentPostsPages, response.data.userPosts])
      setNextPage(response.data.nextPage)
    } catch (e) {
      console.error(e)
    }
  }

  const calloutText = ({ totalPostsCount }) => {
    return totalPostsCount > 0 ? `${totalPostsCount} ${pluralize('Post', totalPostsCount).toUpperCase()}` : ''
  }

  const groupWithinPageByWidth = (recentPostsPages) => {
    return recentPostsPages.flatMap((recentPosts) => {
      return [
        ...recentPosts.filter((post) => !post.fullWidth),
        ...recentPosts.filter((post) => post.fullWidth)
      ]
    })
  }

  return (
    <Section
      expandable
      expanded
      idText='recent-posts'
      padded
    >
      <SectionHeader
        callout={calloutText(props)}
        idText='recent-posts'
        editButton={props.editButton}
      >
        Recent Posts
      </SectionHeader>

      <ExpandedContent>
        <TiledListItems
          listItems={groupWithinPageByWidth(recentPostsPages)}
          supplierId={props.supplierId}
        />
      </ExpandedContent>

      <ViewMoreButton show={nextPage} onViewMore={loadMorePosts} />
    </Section>
  )
}

RecentPostsSection.propTypes = {
  totalPostsCount: PropTypes.number.isRequired,
  recentPosts: PropTypes.arrayOf(TiledListItemShape).isRequired,
  supplierId: PropTypes.number.isRequired,
  nextPage: PropTypes.number,
  editButton: PropTypes.element
}

RecentPostsSection.defaultProps = {
  totalPostsCount: 0,
  recentPosts: []
}

export default RecentPostsSection
